window.Lumera = window.Lumera || {};

Lumera.formatMoney = function (cents) {
  var format = (window.Shopify && window.Shopify.money_format) || '£{{amount}}';
  var amount = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  return format.replace(/\{\{\s*amount\s*\}\}/, amount);
};

Lumera.updateCartCount = function () {
  return fetch('/cart.js')
    .then(function (response) { return response.json(); })
    .then(function (cart) {
      document.querySelectorAll('[data-lumera-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      return cart;
    })
    .catch(function () {});
};

Lumera.addToCart = function (variantId, quantity) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
  }).then(function (response) {
    if (!response.ok) {
      return response.json().then(function (data) {
        throw new Error(data.description || 'add_failed');
      });
    }
    return response.json().then(function (item) {
      Lumera.updateCartCount();
      if (window.Lumera.openCartDrawer) window.Lumera.openCartDrawer();
      return item;
    });
  });
};

Lumera.fetchUpsells = function (productId, limit) {
  if (!productId) return Promise.resolve([]);
  return fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + (limit || 6) + '&intent=related')
    .then(function (r) { return r.ok ? r.json() : { products: [] }; })
    .then(function (data) { return data.products || []; })
    .catch(function () { return []; });
};

Lumera.renderUpsellCard = function (product) {
  var variant = (product.variants || []).filter(function (v) { return v.available; })[0] || (product.variants || [])[0];
  if (!variant) return '';
  var image = (variant.featured_image && variant.featured_image.src) ||
    (typeof product.featured_image === 'string' ? product.featured_image : product.featured_image && product.featured_image.src) ||
    (product.images && product.images[0] && (product.images[0].src || product.images[0])) || '';
  if (image) image += (image.indexOf('?') === -1 ? '?width=240' : '&width=240');
  var url = product.url || ('/products/' + product.handle);
  var title = (product.title || '').replace(/"/g, '&quot;');
  return (
    '<div class="upsell-card">' +
      '<a href="' + url + '">' +
        '<div class="upsell-img"><img src="' + image + '" alt="' + title + '" width="120" height="120" loading="lazy"></div>' +
        '<div class="upsell-title">' + (product.title || '') + '</div>' +
        '<div class="upsell-price">' + Lumera.formatMoney(product.price) + '</div>' +
      '</a>' +
      '<button type="button" class="upsell-add" data-lumera-quick-add data-variant-id="' + variant.id + '">Add</button>' +
    '</div>'
  );
};

Lumera.renderUpsellRail = function (container, seedProductId, excludeIds) {
  if (!container || !seedProductId) return;
  excludeIds = excludeIds || [];
  Lumera.fetchUpsells(seedProductId, 6).then(function (products) {
    var filtered = products.filter(function (p) { return excludeIds.indexOf(p.id) === -1; }).slice(0, 4);
    if (!filtered.length) {
      container.hidden = true;
      container.innerHTML = '';
      return;
    }
    container.hidden = false;
    container.innerHTML =
      '<div class="upsell-head">You may also like</div>' +
      '<div class="upsell-track">' + filtered.map(Lumera.renderUpsellCard).join('') + '</div>';
  });
};

document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-lumera-quick-add]');
  if (!button || button.disabled) return;
  event.preventDefault();
  event.stopPropagation();

  var originalText = button.textContent;
  button.disabled = true;
  button.textContent = '...';

  Lumera.addToCart(button.dataset.variantId, 1)
    .then(function () {
      button.textContent = 'Added ✓';
      window.setTimeout(function () {
        button.textContent = originalText;
        button.disabled = false;
      }, 1600);
    })
    .catch(function () {
      button.textContent = 'Try again';
      button.disabled = false;
    });
});
